<template>
  <div class="todo-notification-overlay" v-if="showNotification">
    <div class="todo-notification">
      <div class="todo-notification-header">
        <h3>wespace.cn停服升级通知</h3>
        <i @click="handleLater" class="el-icon-close"></i>
      </div>
      <div class="todo-notification-content">
        <p>
          为了进一步提升平台性能，保障系统安全。自2026年2月3日上午9点进行停服维护，预计2026年2月6日恢复服务。给您带来的不便，敬请谅解！如有需求请联系：010-65802399
          <!-- <span style="color: #f41717">{{ unreadCount }}</span> -->
        </p>
      </div>
      <el-divider></el-divider>
      <div class="todo-notification-actions">
        <!-- <el-button size="small" @click="handleLater">稍后处理</el-button> -->
        <el-button type="primary" size="small" @click="handleView"
          >知道了</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TodoNotification",
  data() {
    return {
      showNotification: true,
      timer: null,
      hasDisplayed: false // 标记是否已经显示过
    };
  },
  computed: {
    unreadCount() {
      // 从全局状态获取未读数量，默认为3
      return (
        (this.$store.state.unreadMessage &&
          parseInt(this.$store.state.unreadMessage)) ||
        3
      );
    },
    isLoggedIn() {
      // 检查用户是否已登录
      return this.$store.state && 
             this.$store.state.userData && 
             Object.keys(this.$store.state.userData).length > 0;
    },
    // 使用固定的存储键名
    storageKey() {
      return 'todo_notification_displayed';
    }
  },
  watch: {
    // 监听登录状态变化
    isLoggedIn: {
      handler(newVal) {
        if (newVal && this.unreadCount > 0 && !this.hasDisplayed) {
          this.checkAndShowNotification();
        }
      },
      immediate: true // 立即执行一次
    }
  },
  mounted() {
    // 初始化时检查是否已经显示过
    this.checkAndShowNotification();
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  },
  methods: {
    // 统一的检查和显示逻辑
    checkAndShowNotification() {
      // 如果已经显示过，则不再显示
      if (this.hasDisplayed) return;
      
      try {
        // 检查本地存储中是否已经显示过
        const hasDisplayedBefore = localStorage.getItem(this.storageKey);
        if (hasDisplayedBefore) {
          this.hasDisplayed = true;
          return;
        }
        
        // 如果用户已登录且有未读消息，则显示通知
        if (this.isLoggedIn && this.unreadCount > 0) {
          // 延迟显示，确保页面完全加载
          this.timer = setTimeout(() => {
            this.showNotification = true;
            this.hasDisplayed = true;
            // 标记已显示到本地存储
            localStorage.setItem(this.storageKey, 'true');
          }, 1000);
        }
      } catch (error) {
        console.error('检查通知显示状态失败:', error);
        // 即使发生错误，也允许显示通知
        if (this.isLoggedIn && this.unreadCount > 0 && !this.hasDisplayed) {
          this.timer = setTimeout(() => {
            this.showNotification = true;
            this.hasDisplayed = true;
          }, 1000);
        }
      }
    },
    
    handleView() {
      // 点击查看按钮的处理逻辑
      this.showNotification = false;
      // 这里可以添加跳转到待办事项页面或者打开悬浮框的逻辑
      const todoFloatBox = this.$parent.$refs.todoFloatBox;
      if (todoFloatBox && typeof todoFloatBox.toggleShow === "function") {
        todoFloatBox.toggleShow();
      }
    },
    
    handleLater() {
      // 点击稍后处理按钮的处理逻辑
      this.showNotification = false;
    },
  },
};
</script>

<style scoped>
.todo-notification-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  margin-bottom: 20px;
}
.todo-notification-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  animation: fadeIn 0.3s ease;
}
.el-icon-close {
  font-size: 22px;
  color: #606266;
  cursor: pointer;
  margin-top: -20px;
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.todo-notification {
  background-color: white;
  border-radius: 8px;
  padding: 24px;
  width: 490px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideIn 0.3s ease;
  display: flex;
  flex-direction: column;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.todo-notification-content p {
  margin: 0 0 20px 0;
  font-size: 14px;
  color: #606266;
  line-height: 1.5;
}

.todo-notification-actions {
  width: 100%;
  display: flex;
  justify-content: end;
  gap: 12px;
}

.todo-notification-actions .el-button {
  padding: 6px 20px;
}

@media screen and (max-width: 480px) {
  .todo-notification {
    width: 90%;
    padding: 20px;
  }

  .todo-notification-actions {
    flex-direction: column;
    width: 100%;
  }

  .todo-notification-actions .el-button {
    width: 100%;
  }
}
</style>